export default __webpack_public_path__ + "static/media/Pot1.528ad19c.svg";